import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import productDescriptionEntry from '@/components/Blue/ProductDetailPage/Modules/ProductDescriptionEntry.vue';
import productDescriptionEntryDetails from '@/components/Blue/ProductDetailPage/Modules/ProductDescriptionEntryDetails.vue';
import productDescriptionEntryGarantie from '@/components/Blue/ProductDetailPage/Modules/ProductDescriptionEntryGarantie.vue';
import productDescriptionEntryBewertungen from '@/components/Blue/ProductDetailPage/Modules/ProductDescriptionEntryBewertungen.vue';
export default defineComponent({
    name: 'product-description',
    components: {
        productDescriptionEntry,
        productDescriptionEntryDetails,
        productDescriptionEntryBewertungen,
        productDescriptionEntryGarantie,
    },
    computed: Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })),
});
